import { BusinessStatusListEnum } from '../../enums/business-status-list-enum';
import { StatusFilterEnum } from '../../enums/status-filter-and-counters/status-filter-enum';
import { ManagementStatusListEnum } from '../../enums/management-status-list-enum';

export interface FilterConfig {
  id: string
  translation: string,
  locationCountClass: string
}

export const OrderedFilterConfig: FilterConfig[] = [
  {
    id: StatusFilterEnum.IS_DIFFERENT_IN_MY_BUSINESS,
    translation: 'Open differences',
    locationCountClass: 'coloredLocationCountOutlined locationDifferencesColoring',
  },
  {
    id: StatusFilterEnum.IS_NOT_FOUND_IN_MY_BUSINESS,
    translation: 'Missing',
    locationCountClass: 'coloredLocationCount locationMissingColoring',
  },
  {
    id: BusinessStatusListEnum.CLOSED_TEMPORARILY,
    translation: 'Temporarily closed',
    locationCountClass: 'coloredLocationCountOutlined locationBusinessStatusColoring',
  },
  {
    id: BusinessStatusListEnum.CLOSED_PERMANENTLY,
    translation: 'Permanently closed',
    locationCountClass: 'coloredLocationCount locationBusinessStatusColoring',
  },
  {
    id: StatusFilterEnum.HAS_UPDATE_ERROR,
    translation: 'Update error',
    locationCountClass: 'coloredLocationCount locationUpdateErrorColoring',
  },
  {
    id: StatusFilterEnum.HAS_IMPORT_ERROR,
    translation: 'Import error',
    locationCountClass: 'coloredLocationCount locationImportErrorColoring',
  },
  {
    id: ManagementStatusListEnum.NOT_MANAGED,
    translation: 'Not managed',
    locationCountClass: 'coloredLocationCount locationNotManagedColoring',
  },
  {
    id: ManagementStatusListEnum.MANUALLY_MANAGED,
    translation: 'Manually managed',
    locationCountClass: 'coloredLocationCountOutlined locationNotManagedColoring',
  },
  {
    id: StatusFilterEnum.HAS_IGNORED_DIFFERENCES,
    translation: 'Accepted differences',
    locationCountClass: 'coloredLocationCount locationDifferencesColoring',
  },
  {
    id: StatusFilterEnum.HAS_BLACKLISTED_FIELDS,
    translation: 'Blacklisted fields',
    locationCountClass: 'coloredLocationCount locationBlacklistedFieldsColoring',
  },
  {
    id: StatusFilterEnum.IS_NOT_VERIFIED,
    translation: 'Not validated',
    locationCountClass: 'coloredLocationCount locationNotValidatedColoring',
  },
  {
    id: StatusFilterEnum.HAS_COMPLETED_CC,
    translation: 'Completed C&C',
    locationCountClass: 'coloredLocationCount locationHasCompletedCcColoring',
  },
];